import { vm } from '@/main'
import { Dispatcher } from '@/APIDispatcher'

export const PublisherApi = {

  listPublishers () {
    return new Promise((resolve, reject) => {
      let promise = Dispatcher.post('publishers/list', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.publishers)
        } else {
          vm.$notify.error('List Failed', 'Publisher list failed: ' +
                            s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  publisherDetails (companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publisher/details', { company_id: companyId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.publisher)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  publisherSet (publisher) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/set', { publisher: publisher }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('Create Failed', 'Publisher creation failed: ' +
                            s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  mediumDetails (companyId, medId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/medium/details',
        { company_id: companyId, med_id: medId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.medium)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  publisherMediumSet (medium) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/medium/set', { medium }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('Medium Settings Failed', 'Publisher medium creation failed: ' +
                            s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  listPublisherMediums (companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/medium/list', { company_id: companyId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.mediums)
        } else {
          vm.$notify.error('List Failed', 'Failed to list mediums!')
        }
      })
    })
  },

  listPublisherTags (companyId, medId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/tag/list',
        { company_id: companyId, med_id: medId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.tags)
        } else {
          vm.$notify.error('List Failed', 'Failed to list tags!')
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  publisherTagSet (tag) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/tag/set', { tag }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.tag)
        } else {
          vm.$notify.error('Create Failed', 'Publisher tag creation failed: ' +
                            s.errorCode)
        }
      })
    })
  },

  tagDetails (companyId, medId, zoneId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/tag/details',
        { company_id: companyId, med_id: medId, zone_id: zoneId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.tag)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  adsTxt (companyId, medId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publisher/medium/adstxt', { company_id: companyId, med_id: medId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.entries)
        } else {
          reject(Error(s.errorCode))
        }
      })
    })
  },

  //deprecated, this don't work
  reportByDate (start, end, groupBy, total, masterId, medId, zoneId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('publishers/report',
      {
        start: start,
        end: end,
        groupby: groupBy,
        total: total,
        masterId: masterId,
        medId: medId,
        zoneId: zoneId
      }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          reject(new Error(s.errorCode))
          vm.$notify.error('Report Error', 'Failed to pull report: ' + s.errorCode)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/publisher/api.js